<template>
  <div class="stat-courier-page">
    <v-container fluid>
      <stat-top-filter
        :days-count="30"
        :filial-default="globalFilialId"
        @applyFilter="fetchData"
      />

      <!--      start-date="2022-06-01"
      end-date="2022-06-05"-->

      <loader v-if="loading" />
      <template v-else>
        <div>
          <courier-stat-table
            :table-data="statCourier"
            :user-colors="userColors"
          />
        </div>
        <div v-if="statCourier.length" class="courier-stat-charts">
          <v-row>
            <v-col md="6" cols="12">
              <courier-chart-item
                title="Опоздания курьеров"
                :stat-data="statCourier"
                column-name="delays"
                :user-colors="userColors"
              />
            </v-col>
            <v-col md="6" cols="12">
              <courier-chart-item
                title="Доля от всех заказов"
                :stat-data="statCourier"
                column-name="orderDelivered"
                :user-colors="userColors"
              />
            </v-col>
          </v-row>
        </div>
      </template>
    </v-container>
  </div>
</template>

<script>
  import Loader from '@/components/loader/Loader'
  import CourierStatTable from '@/components/stat/courirs/CourierTable'
  import StatTopFilter from '@/components/stat/StatTopFilter'
  import CourierChartItem from '@/components/stat/courirs/CourierChartItem'
  import { mapGetters } from 'vuex'

  export default {
    name: 'CourierStat',
    components: { CourierChartItem, StatTopFilter, CourierStatTable, Loader },
    data () {
      return {
        showDaysCount: 30,
        loading: false,
        statisticCourier: [],
      }
    },
    computed: {
      ...mapGetters({
        globalFilialId: 'branches/getGlobalFilialId',
      }),
      statCourier () {
        return this.statisticCourier ?? []
      },

      userColors () {
        return this.statCourier.reduce(
          (previousValue, item) => {
            previousValue[item.user.id] = this.getRandomColor()
            return previousValue
          },
          {},
        )
      },
    },

    created () {
      // this.fetchData()
    },
    methods: {
      fetchData (filter) {
        console.log(filter)
        this.loading = true
        const payload = {
          from: filter.from,
          to: filter.to,
          filialId: filter.filialId,
          filialPreset: filter.filialPreset,
        }
        this.statisticCourier = []
        this.$store.dispatch('statistic/fetchCourierStatisticTables', payload)
          .then((res) => {
            this.statisticCourier = res
          })
          .catch((err) => this.showErrorFromResponse(err))
          .finally(() => {
            this.loading = false
          })
      },
      getRandomColor () {
        const letters = '0123456789ABCDEF'
        let color = '#'
        for (let i = 0; i < 6; i++) {
          color += letters[Math.floor(Math.random() * 16)]
        }
        return color
      },
    },
  }
</script>

<style lang="less">
@import "src/assets/styles/statistic.less";
.stat-courier-page {

}
</style>
